export default __webpack_public_path__ + "static/media/close.15eb07f1.svg";